<!--
 * @Descripttion: 隐私政策
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-18 09:45:40
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-07-21 10:48:12
-->
<template>
  <div class="word privacy_policy p-t-100 p-b-50">
    <!-- <div class="ui-banner-section">
      <div class="ui-banner-section-inner-title center_up_down_left_right">隐私政策</div>
    </div> -->
    <div class="container ui-common-list">
      <div class="word-main">
        <div class="word-main-list" v-for="(item,index) in $t('privacyPolicy.list')" :key="index">
          <div class="title"><span v-html="item.title"></span><i class="line"></i></div>
          <div class="des" v-for="(list,i) in item.des" :key="i" v-html="list"></div>
        </div>
        <div>
          <div>{{$t('privacyPolicy.bottom')[0]}}</div>
          <div>{{$t('privacyPolicy.bottom')[1]}}</div>
          <div>{{$t('privacyPolicy.bottom')[2]}}</div>
          <div>{{$t('privacyPolicy.bottom')[3]}}</div>
          <div class="textr">{{$t('privacyPolicy.time')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang="less">
.pc .privacy_policy{
  .ui-common-list{
    padding-top: 20PX;
  }
}
</style>
